const DISALLOWED_VIN_CHARS_REGEX = /[^A-HJ-NPR-Z0-9]/g;

export function transformPaste(e: React.ClipboardEvent<HTMLInputElement>) {
  const input = e.currentTarget;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const maxLength = input.maxLength < 0 ? Infinity : input.maxLength;
  const remainingLength = Math.max(
    0,
    maxLength - (input.value.length - (selectionEnd - selectionStart))
  );

  const toBePasted = e.clipboardData
    .getData('text')
    .toUpperCase()
    .replace(DISALLOWED_VIN_CHARS_REGEX, '')
    .slice(0, remainingLength);

  input.setRangeText(toBePasted, selectionStart, selectionEnd, 'end');

  input.dispatchEvent(new Event('input', {bubbles: true}));
  e.preventDefault();
}
